import { ListViewGroup, ListViewRow, Stack, Text } from '@ekhodealer/ekho-common/rev';

import type { OptionalVehicleAccessory } from '@ekhodealer/ekho-common';

import { EmptySection } from '@common/components/EmptySection';

import { AccessoryLineItem } from './AccessoryLineItem';

interface AccessoriesListViewProps {
	accessories: Array<OptionalVehicleAccessory>;
	/** Optional title to show above the list. Defaults to 'PG&A' */
	title?: string;
	/** Optional empty message. Defaults to 'No accessories available' */
	emptyMessage?: string;
}

/**
 * Reusable component for displaying a list of vehicle accessories
 * Used across orders and leads features
 */
export const AccessoriesListView = ({
	accessories,
	title = 'PG&A',
	emptyMessage = 'No accessories available',
}: AccessoriesListViewProps) => {
	return (
		<>
			{title && (
				<Text size='footnote' weight='semibold'>
					{title}
				</Text>
			)}
			<ListViewGroup aria-label={title}>
				{accessories && accessories.length > 0 ? (
					accessories.map((item, index: number) => (
						<ListViewRow
							key={index}
							bottomContent={<AccessoryLineItem accessory={item} />}
						/>
					))
				) : (
					<Stack>
						<EmptySection message={emptyMessage} />
					</Stack>
				)}
			</ListViewGroup>
		</>
	);
};
